import React, { useState } from "react";
import { Flower2, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const HERO =
  "https://images.unsplash.com/photo-1526047932273-341f2a7631f9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

const DEMO = [
  { label: "Owner", email: "owner@florist.id" },
  { label: "Manager", email: "manager@florist.id" },
  { label: "Kasir", email: "kasir@florist.id" },
  { label: "Arranger", email: "arranger@florist.id" },
];

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("owner@florist.id");
  const [password, setPassword] = useState("florist123");
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try {
      await login(email.trim(), password);
    } catch (e2) {
      setErr(e2.message || "Login gagal");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:block relative flex-1">
        <img src={HERO} alt="florist" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1b3324]/85 via-[#1b3324]/30 to-transparent" />
        <div className="absolute bottom-0 p-12 text-white">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-11 h-11 rounded-xl bg-white/15 backdrop-blur flex items-center justify-center">
              <Flower2 size={24} />
            </div>
            <span className="text-3xl font-bold">FloristOS</span>
          </div>
          <p className="text-lg text-white/90 max-w-md">
            POS · Inventory · Produksi untuk toko bunga multi-cabang. Kini hadir di web.
          </p>
        </div>
      </div>

      <div className="w-full lg:w-[480px] flex items-center justify-center p-8 bg-[#F4F8F4]">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-2.5 mb-8">
            <div className="w-10 h-10 rounded-xl bg-primary flex items-center justify-center text-white">
              <Flower2 size={22} />
            </div>
            <span className="text-2xl font-bold text-slate-800">FloristOS</span>
          </div>
          <h1 className="text-2xl font-semibold text-slate-800">Masuk</h1>
          <p className="text-sm text-slate-500 mt-1 mb-6">Selamat datang kembali. Silakan masuk ke akun Anda.</p>

          <form onSubmit={submit} className="space-y-4">
            <label className="block">
              <span className="text-sm font-medium text-slate-600 mb-1.5 block">Email atau Username</span>
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoCapitalize="none"
                placeholder="nama@toko.id"
                data-testid="login-email"
                className="w-full h-11 px-3.5 rounded-xl border border-slate-300 bg-white outline-none focus:border-primary focus:ring-2 focus:ring-primary/20"
              />
            </label>
            <label className="block">
              <span className="text-sm font-medium text-slate-600 mb-1.5 block">Password</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                data-testid="login-password"
                className="w-full h-11 px-3.5 rounded-xl border border-slate-300 bg-white outline-none focus:border-primary focus:ring-2 focus:ring-primary/20"
              />
            </label>
            {err && <div className="text-sm text-rose-600 bg-rose-50 rounded-lg px-3 py-2" data-testid="login-error">{err}</div>}
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full h-11 rounded-xl bg-primary text-white font-semibold hover:bg-primary/90 transition disabled:opacity-60 flex items-center justify-center gap-2"
            >
              {loading && <Loader2 className="animate-spin" size={18} />}
              Sign In
            </button>
          </form>

          <div className="mt-8">
            <p className="text-xs text-slate-400 mb-2">Akun demo (password: florist123)</p>
            <div className="flex flex-wrap gap-2">
              {DEMO.map((d) => (
                <button
                  key={d.email}
                  onClick={() => setEmail(d.email)}
                  data-testid={`demo-${d.label.toLowerCase()}`}
                  className="px-3 h-8 rounded-full bg-primary/10 text-primary text-xs font-medium hover:bg-primary/20"
                >
                  {d.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
